import { render, staticRenderFns } from "./CommonLogin.vue?vue&type=template&id=29bb2cb2"
import script from "./CommonLogin.vue?vue&type=script&lang=js"
export * from "./CommonLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29bb2cb2')) {
      api.createRecord('29bb2cb2', component.options)
    } else {
      api.reload('29bb2cb2', component.options)
    }
    module.hot.accept("./CommonLogin.vue?vue&type=template&id=29bb2cb2", function () {
      api.rerender('29bb2cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/login/CommonLogin.vue"
export default component.exports